import React, { Component } from 'react';
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom';
import qs from 'query-string';
import classNames from 'classnames';
import SpinnerDots from '../../components/spinner/dots';
import withAuthProvider from '../../hoc/withAuthProvider';
import withFetch from '../../hoc/withFetch';
//import Footer from '../../components/footer';
import Posts from '../../components/posts';
import Breadcrumb from '../../components/breadcrumb';
import { REACT_APP_API_BASE } from '../../config';

class Blog extends Component {
    constructor(props) {
        super(props);
        
        const { location } = this.props;
        const query = qs.parse(location.search);

        this.state = {
            page: query.page ? parseInt(query.page) : 1,
            news: [],
            total_pages: null,
            fetch:0, 
            isLoading: false
        };
    }

    async componentDidUpdate(prevProps, prevState) {
        
        const { location } = this.props;
        const query = qs.parse(location.search);
        let page = query.page ? parseInt(query.page) : 1;
        
        if (!this.props.isAuthenticated) return;

        if (this.state.fetch !== prevState.fetch) return;

        if (this.state.isLoading) return;

        const data = await this.dataFetcher();
        this.setState({
            isLoading: false,
            ...data,
            news: [...this.state.news, ...data.news],
            page,
            fetch: this.state.fetch + 1,
        });  
    }

    async dataFetcher() {
        const { match } = this.props;

        const { location } = this.props;
        const query = qs.parse(location.search);
        const currentPage = isNaN(parseInt(query.page)) ? 1 : parseInt(query.page);
        const skip = (currentPage-1) * 12;

        this.setState({
            isLoading: true
        });

        let tags = '';
        if (match.params.tag) {
            tags = `&newsTags=${match.params.tag}`;
        }

        const res = await this.props.fetch(`${REACT_APP_API_BASE}/online/news?skip=${skip}&take=12${tags}`);
        
        if(!res.ok) return {};
        
        const data = await res.json();
        
        return { 
            ...data
        };
    }

    async requestInitialDataClient(query) {
        return await this.dataFetcher(query);
    }

    render() {
        const { location } = this.props;
        const { match } = this.props;

        return (
            <section className={classNames({
                'blog-items': true,
                'blog-items--is-loading': this.state.isLoading
            })}>
                {match.params && match.params.tag &&
                    <Breadcrumb url="/news" link_text="Visa alla nyheter" />
                }
                <div className="blog-items__wrapper">
                    <h1>Nyheter</h1>
                    <Posts posts={this.state.news} />
                    {this.state.hasMore &&
                        <Link className="blog-items__load-more"
                            to={{
                                pathname: location.pathname,
                                search: `?page=${parseInt(this.state.page) + 1}`
                            }}>Visa fler</Link>
                    }
                </div>
                <SpinnerDots />
            </section> 
        );
    }
    
};
export default withAuthProvider(withFetch(withRouter(Blog)));